'use strict';

const $ = require('jquery');
const util = require('../../utils/util');
const lazyload = require('../../utils/lazyload');
const uniform = require('../uniform');
const offcanvasdialog = require('../offcanvasdialog');
const keyCodes = require('../../constants/key-strings').default;
const fitGuideOnClickEvents = require('../../fitguide/fitguideevents');
const fitguideselectedmillimeters = require('../../fitguide/fitguideselectedmillimeters');

const isPDP = $('#pdpMain').length > 0;
const isCart = $('#cartWarning').length > 0;
const isQuickShop = $('.search-result-wrapper').length > 0;
let initialized = false;
let sizes;

try {
    sizes = JSON.parse(SitePreferences.fitGuideSizeChart);
} catch (e) {
    sizes = {};
}

/**
 * Sets up the keyboard navigation flow so that the user can loop forwards and backwards
 * through all elements that are interactive using Tab and Tab + Shift.
 *
 * @param {jQuery object} $container
 * @returns {void}
 */
function setUpADA($container) {
    let $tabbable = $container.findTabbable();
    let $firstTabbable = $tabbable.first();
    let $lastTabbable = $tabbable.last();

    $firstTabbable.on('keydown', function (e) {
        if (e.key === keyCodes.TAB && e.shiftKey) {
            $lastTabbable.focus();
        }
    });

    $lastTabbable.on('keydown', function (e) {
        if (e.key === keyCodes.TAB && !e.shiftKey) {
            $firstTabbable.focus();
        }
    });
}

/**
 * Initializes fit guide.
 *
 * @returns {void}
 */
function initializeFitGuide() {
    addHelperClass();
    uniform();
    fitguide();
    sizechart();
    sizeinfo();
    fitGuideOnClickEvents.init(sizes, isPDP, isCart);
}

/**
 * Initializes fit guide fly-ins.
 *
 * @returns {void}
 */
function initializeFlyin() {
    offcanvasdialog.init(
        'flyin-product-info-fit-guide',
        {
            overlay: true,
            additionalClass: 'fit-guide-flyin',
            closeIconClass: 'icon-close-thin',
            reloadContentAlways: true
        },
        function ($triggerButton, $flyinContainer) {
            const $flyinContent = $flyinContainer.find('.ocd-content');
            const $flyinCloseButton = $flyinContainer.find('.ocd-close');

            // Move close button so that it is a sibling of the main content container.
            // That way the button isn't lost when the fly-in's content is reloaded.
            $flyinCloseButton.detach().appendTo($flyinContainer);

            $flyinContainer.on('opened', function () {
                setUpADA($flyinContainer);
            });

            // The fly-in starts with only one page loaded - make it's content visible.
            $flyinContent.children().first().addClass('active');

            initializeFitGuide();

            // Additional sub-pages are loaded by making a single AJAX call per sub-page
            // and are then opened/closed by adding/removing the .active class.
            // This is done to reduce network traffic and maintain the sub-page state.
            $('.info-overlay a, .on-product-page .container-result a').click(function (e) {
                e.preventDefault();

                const pageClass = $(this).attr('class');
                const pageAlreadyLoaded = $flyinContent.children().is('.' + pageClass);
                const mainSizingLocale = $('.fit-guide').data('main-region');

                if (pageAlreadyLoaded) {
                    $flyinContent
                        .children()
                        .filter('.' + pageClass)
                        .addClass('active');
                    $flyinContent.children().first().removeClass('active');

                    setUpADA($flyinContainer);
                } else {
                    $.ajax({
                        url: $(this).attr('href'),
                        type: 'GET',
                        dataType: 'html',
                        data: {
                            mainsizing: mainSizingLocale
                        },
                        success: function (response) {
                            // Hide all fly-in pages.
                            $flyinContent.children().removeClass('active');

                            // Add the new sub-page, give it a unique class and make it visible.
                            $flyinContent.append(response);
                            $flyinContent
                                .children()
                                .last()
                                .addClass(pageClass + ' active');

                            // Add back button
                            $flyinContent
                                .children()
                                .last()
                                .find('.flyin-content')
                                .prepend(
                                    '<button class="button button-trans back-button"><span>' +
                                        Resources.FIT_GUIDE_BACK_TO_CALCULATOR +
                                        '</span></button>'
                                );

                            $flyinContent
                                .children()
                                .last()
                                .find('.back-button')
                                .click(function () {
                                    $flyinContent.children().removeClass('active');
                                    $flyinContent.children().first().addClass('active');
                                });

                            initializeFitGuide();
                            setUpADA($flyinContainer);
                        }
                    });
                }
            });
        }
    );
}

/**
 * Adds an additional class to help determine the location of the fit guide calculator.
 *
 * @returns {void}
 */
function addHelperClass() {
    $('.fit-guide').addClass(function () {
        return isPDP || isCart || isQuickShop ? 'on-product-page' : 'on-landing-page';
    });
}

var fitguide = function () {
    const $fitGuideCalculator = $('.fit-guide-calculator');
    const $fitGuideForm = $fitGuideCalculator.find('.fit-guide-form');
    const $fitGuideResult = $fitGuideCalculator.find('.container-result');
    const $measurementFields = $fitGuideCalculator.find('.select-wrapper select');

    fitguideselectedmillimeters.init(sizes);

    lazyload.init();

    // Clean up and reorder elements based on the current page.
    if (isPDP || isCart || isQuickShop) {
        $fitGuideResult.find('button.show-products').remove();
    } else {
        $fitGuideForm.find('.warning-form').detach().prependTo($fitGuideForm);
    }

    $measurementFields.on('change', function () {
        $(this).closest('.form-row').removeClass('validation-error');
        $(this).closest('.form-row').addClass('chosen-size');
    });
};

function sizechart() {
    const $fitGuideSizeInfo = $('.fit-guide-size-chart');
    const $fitGuideSizeContainer = $fitGuideSizeInfo.find('.fit-guide-size-chart-content');
    const $fitGuideSizeTabs = $fitGuideSizeInfo.find('.navigation-tabs');
    const $fitGuideSizeTab = $fitGuideSizeTabs.find('.size-chart-tab');
    const mainSizingLocale = $('.fit-guide').data('main-region');

    if (mainSizingLocale) {
        $('.flyin-product-info-fit-guide').each(function (i, item) {
            const itemHref = item.href || item.getAttribute('data-href');
            if (!itemHref.includes('mainsizing')) {
                const updatedURL = util.appendParamToURL(itemHref, 'mainsizing', mainSizingLocale);
                if (item.href) {
                    $(item).attr('href', updatedURL);
                } else {
                    $(item).attr('data-href', updatedURL);
                }
            }
        });
    }

    $fitGuideSizeTab.off().on('click keypress', function () {
        if (util.isClickOrSpaceOrEnter(event)) {
            const index = $fitGuideSizeTabs.find('div').index($(this));
            $fitGuideSizeTab.removeClass('active');
            $(this).addClass('active');
            $fitGuideSizeContainer.find('div').removeClass('active');
            $fitGuideSizeContainer.find('div').eq(index).addClass('active');
        }
    });
}

function sizeinfo() {
    const $fitGuideSizeInfo = $('.fit-guide-measure-wrapper');
    const $fitGuideSizeContainer = $fitGuideSizeInfo.find('.fit-guide-container');
    const $fitGuideSizeTabs = $fitGuideSizeInfo.find('.fit-guide-tabs');
    const $fitGuideSizeTab = $fitGuideSizeTabs.find('.fit-guide-tab');

    $fitGuideSizeTab.off().on('click keypress', function () {
        if (util.isClickOrSpaceOrEnter(event)) {
            const index = $fitGuideSizeTabs.find('div').index($(this));
            $fitGuideSizeTab.removeClass('active');
            $(this).addClass('active');
            $fitGuideSizeContainer.find('div').removeClass('active');
            $fitGuideSizeContainer.find('div').eq(index).addClass('active');
        }
    });
}

const init = () => {
    initialized = true;
    initializeFitGuide();
    initializeFlyin();
};

module.exports = {
    init,
    isInitialized: () => initialized
};
